export const capitalizeAWord = word => word && word.length && [].concat(word.split('')[0].toUpperCase(), word.slice(1)).join('')
